import { styled } from "@mui/system";
export default styled("div")({
  marginTop: 50,
  marginBottom: 50,
  width: "100%",
  height: 2,
  opacity: 0.8,
  backgroundColor: "#e6e7e8"
});